import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { IMember } from "../Domains/member";
import { MessageService, ConfirmationService } from "primeng/api";
import { IMemberContact } from "../Domains/memberContact";
import { IAddress } from "../Domains/address";
import { AppServiceManager } from "common/services/appServiceManager";
import { Router, ActivatedRoute } from "@angular/router";
import { Configuration } from "config/config";
import { HttpClient } from "@angular/common/http";
import { ICompany } from "../Domains/company";
import { IMemberFeeDetails } from "../Domains/feeDetail";
import { ISettings } from "../Domains/settings";
import { IMemberEmergencyContact } from "../Domains/memberEmergencyContact";
import { WebcamImage } from "ngx-webcam";
import { IMemberFreezeDetail } from "../Domains/memberFreezeDetail";
import { Customerstrainer } from "../Domains/Customerstrainer";
import { forkJoin } from "rxjs";
import { IPackageBuider } from "../Domains/packageBuilder";
import { IUser } from "../Domains/IUser";
import { AuthService } from "common/services/auth.service";
import { MemberService } from "common/services/member.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ReceiptPrintComponent } from "../receipt/receipt-print/receipt-print.component";
import globalVariable from "../../../globalVariable/globalVariable.json";
import { IEmailFields } from "../Domains/emailFields";
import { DatePipe } from "@angular/common";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
import { mergeMap } from "rxjs/operators";
import { IBranch } from "../Domains/branch";
import { AppUtils } from "common/services/app.util";
import {
    buildMemberUpdatePayload,
    customerGetUrl,
    customerUpdateUrl,
} from "common/services/member-update-payload.util";
// import {EditorModule} from 'primeng/editor';
import { LanguageService } from 'app/LanguageService/Language.Service';
import moment from "moment";
import { IBusinessRule } from "../Domains/businessRule";

@Component({
    selector: "app-signup",
    host: { "(window:keyup)": "signUpHotkeys($event)" },
    templateUrl: "./signup.component.html",
    styleUrls: ["./signup.component.css"],
})
export class SignupComponent implements OnInit {
    public Editor = ClassicEditor;
    powerByNumber: any;
    @ViewChild(ReceiptPrintComponent) private receiptComponent;
    member: IMember;
    @ViewChild("memberName") membernameInput: ElementRef;
    @ViewChild("packageName", { static: false }) packageNameInput: ElementRef;
    @ViewChild("gender") genderControl: ElementRef;
    @ViewChild("dd") dropdown;
    @ViewChild("printButton", { static: false }) printButton: ElementRef;
    packages: IPackageBuider[] = [];
    sourcePackages: IPackageBuider[];
    package: IPackageBuider;
    user: IUser;
    passwordType: string = "password";
    loading: boolean;
    items: any[];
    fund: IMemberFeeDetails;
    freezeDetail: IMemberFreezeDetail;
    activeIndex: any;
    company: ICompany;
    uploadProfile: any;
    bool: boolean;
    uploadProfilePath: any;
    sortedTrainers: any[];
    Trainers: any[];
    sourceTrainers: any[];
    options: any[] = [];
    x: Boolean;
    registrationFund: IMemberFeeDetails;
    trainerFund: IMemberFeeDetails;
    memberIDS: any[];
    selectedOption: any;
    fundInvoice: IMemberFeeDetails;
    dialogVisibility: boolean;
    feeInvoiceDialog: boolean;
    statusOptions: any[];
    months: any[];
    years: any[];
    public webcamImage: WebcamImage = null;
    feesServicesCall: any[] = [];
    memeberServicesCall: any[] = [];
    memeberUpdateServicesCall: any[] = [];
    noOfMembers: number = 1;
    index: number = 0;
    memberItems: any[] = [];
    members: IMember[] = [];
    isMembersRegistered: boolean = false;
    totalPackageFee: number = 0;
    totalReceivedFee: number = 0;
    totalRegistrationPackageFee: number = 0;
    totalTrainerFee: number = 0;
    existMembers: IMember[] = [];
    existMembersddOptions: any[] = [];
    existingMembersDialog: boolean = false;
    selectedExistMember: string;
    countries: any[] = [];
    subPackage: IPackageBuider;
    invoicePrint: boolean = false;
    genderOptions: { label: string; value: string }[];
    focusedIdx: any;
    count: number = 0;
    numb: number = 0;
    addProfileImage: any;
    isShowAddProfileImage: boolean;
    showPrint: boolean = false;
    showEmailReceiptConfirmationBox: boolean = false;
    email: IEmailFields = new IEmailFields();
    enterSteps: any[];
    currentStep: any;
    receiptHtml: any;
    printInvoiceMembers: IMember[] = [];
    branch: IBranch;
    counterCheck : any;
    noofMonths: number;
    registrationDiscount: number = 0;
    trainerDiscount: number = 0;
    monthlyDiscount: number = 0;
    packageFeeType: string;
    packageRegFeeType: string;
    packageName: string;
    packageType: string;
    dateOfJoining: Date;
    paymentMode :string;
    currentUserData: any;
    member_id:string;
    onlineMembers:any;
    taxType: any;
    taxRate: any;
    durationType: string;
    businessRules:  IBusinessRule;
    isDiscountFormulaReverse: boolean

    constructor(
        private LanguageService: LanguageService,
        private router: Router,
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        public config: Configuration,
        private _http: HttpClient,
        private appServiceManager: AppServiceManager,
        private messageService: MessageService,
        private loader: NgxSpinnerService,
        private elementRef: ElementRef,
        private datePipe: DatePipe,

    ) { }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("SignupComponent", label);
      }
    ngOnInit() {
        const currentUser = localStorage.getItem('currentUser');
        this.currentUserData = JSON.parse(currentUser);
        this.InitObjects();
        this.user = AuthService.getLoggedInUser();
        this.getPackages();
        this.powerByNumber = globalVariable.suportInfo.mobile;
        this.activeIndex = 0;
        this.member.feeDetails = [];
        this.member.joiningDate = new Date();
        this.member.profile = "assets/layout/images/avatarBoyImage.png";
        this.member.gender = "M";
        this.member.question1 = "NO";
        this.dialogVisibility = false;
        this.loading = false;
        this.feeInvoiceDialog = false;
        this.x = false;
        this.member.registerationFee = "0";
        this.getTrainers();
        this.getCompany();
        this.getBranch();
        // this.getAutoMemberID();
        this.currentStep = 0;
        this.enterSteps = [
            "printButton",
            "sendReceiptButton",
            "finishButton"
        ];

        this.items = [
            {
                label: "Membership",
                command: (event: any) => {
                    this.activeIndex = 0;
                    this.validateSignup();
                },
            },
            {
                label: "Details",
                command: (event: any) => {
                    this.activeIndex = 1;
                    this.validateSignup();
                },
            },
            {
                label: "Fee Collect",
                command: (event: any) => {
                    this.activeIndex = 2;
                },
            },
            {
                label: "Fee Invoice",
                command: (event: any) => {
                    this.activeIndex = 3;
                },
            },
        ];

        const enquiry = this.route.snapshot.queryParamMap.get("enquiry");
        if (enquiry != null) {
            this.getEnquiryMember();
        };

    }

    ngAfterViewInit() {
        this.packageNameInput.nativeElement.focus();
    }

    InitObjects() {
        this.addProfileImage = "Cam"; // Upload | Cam
        this.isShowAddProfileImage = false;
        this.member = new IMember();
        this.company = new ICompany();
        this.branch = new IBranch();
        this.member.contactDetail = new IMemberContact();
        this.freezeDetail = new IMemberFreezeDetail();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        this.member.settings = new ISettings();
        this.fund = new IMemberFeeDetails();
        this.fundInvoice = new IMemberFeeDetails();
        this.package = new IPackageBuider();
        this.subPackage = new IPackageBuider();
        this.user = new IUser();
        this.email = new IEmailFields();

        this.member.contactDetail.address.country = "Pakistan";
        // this.member.contactDetail.address.city = "Islamabad";
        this.statusOptions = [
            { label: "Select Fee Type", value: null },
            { label: "All", value: "All" },
            { label: "Registration Fee", value: "Registration Fee - Paid" },
            { label: "Monthly Fee", value: "Monthly Fee - Paid" },
            { label: "Trainer Fee", value: "Trainer Fee - Paid" },
        ];

        this.months = [
            { label: "Select Month", value: null },
            { label: "January", value: 1 },
            { label: "Febuary", value: 2 },
            { label: "March", value: 3 },
            { label: "April", value: 4 },
            { label: "May", value: 5 },
            { label: "June", value: 6 },
            { label: "July", value: 7 },
            { label: "August", value: 8 },
            { label: "September", value: 9 },
            { label: "October", value: 10 },
            { label: "November", value: 11 },
            { label: "December", value: 12 },
        ];
        this.years = [
            { label: "Select Year", value: null },
            { label: "2015", value: 2015 },
            { label: "2016", value: 2016 },
            { label: "2017", value: 2017 },
            { label: "2018", value: 2018 },
            { label: "2019", value: 2019 },
            { label: "2020", value: 2020 },
            { label: "2021", value: 2021 },
            { label: "2022", value: 2022 },
            { label: "2023", value: 2023 },
            { label: "2024", value: 2024 },
            { label: "2025", value: 2025 },
            { label: "2026", value: 2026 },
            { label: "2027", value: 2027 },
            { label: "2028", value: 2028 },
            { label: "2029", value: 2029 },
            { label: "2030", value: 2030 },
            { label: "2031", value: 2031 },
            { label: "2032", value: 2032 },
            { label: "2033", value: 2033 },
            { label: "2034", value: 2034 },
            { label: "2035", value: 2035 },
            { label: "2036", value: 2036 },
            { label: "2037", value: 2037 },
            { label: "2038", value: 2038 },
            { label: "2039", value: 2039 },
            { label: "2040", value: 2040 },
        ];
    }

    changeWizard() {
        this.activeIndex++;
    }

    getEnquiryMember() {
        let enquiryObj = JSON.parse(
            this.route.snapshot.queryParamMap.get("enquiry")
        );
        this.member = new IMember();
        this.member.contactDetail = new IMemberContact();
        this.member.contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        this.member.name = enquiryObj.name;
        this.member.email = enquiryObj.email;
        this.member.gender = enquiryObj.gender == "Male" ? "M" : "F";
        this.member.contactDetail.contact = enquiryObj.contact;
        this.member.customerstrainer.totalFees = "0";
        // this.member.5.address = enquiryObj.address;
        this.member.profession = enquiryObj.profession;
        this.member.question2 = enquiryObj.question2;
        this.member.question1 = enquiryObj.question1;
        this.member.joiningDate = new Date();
    }

    getPackages() {
        this.packages = [];
        this.loading = true;
        this.loader.show();
        this.appServiceManager
            .get(
                "branches/" +
                this.user.branch +
                "/package-builders"
            )
            .subscribe(
                (res) => {
                    this.packages = res;
                    this.packages = res.filter(x => x.isDelete == false);
                    if (this.packages.length > 0) {
                        this.packages = this.packages.sort((a, b) => { return <any>new Date(a.sn) - <any>new Date(b.sn) });
                        this.sourcePackages = this.packages.sort((a, b) => { return <any>new Date(a.sn) - <any>new Date(b.sn) });
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Packages Record Found",
                        });
                    }
                    this.loading = false;
                    this.loader.hide();
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    getAutoMemberID() {
        let filter = {
            Member: this.member.tagNumber,
            company: this.user.company,
            branch: this.user.branch,
        };
        this.appServiceManager
            .post('branches/' + this.user.branch + '/customers/actions/get-membership', filter)
            .subscribe(
                (member: any) => {
                    if (member.memberShipTag != null) {
                        this.member.tagNumber = member.memberShipTag.toString();
                    }
                },
                (error) => { }
            );
    }
    membershipValidation() {
        if (this.member.tagNumber != "") {
            this.appServiceManager
                .get(
                    "customers/membershipExistValidation/" +
                    this.member.tagNumber
                )
                .subscribe(
                    (res) => {
                        if (res.length > 0) {
                            this.x = true;
                        } else if (res.length == 1) {
                            this.x = true;
                        } else {
                            this.x = false;
                        }
                    },
                    (error) => { }
                );
        }
    }

    dropdownChange() {
        var data = this.Trainers.filter((x) => x._id === this.selectedOption);
        if (data.length > 0) {
            this.member.customerstrainer.trainerId = data[0]._id;
            this.member.customerstrainer.name = data[0].name;
            this.member.customerstrainer.totalFees = data[0].totalFees
                ? data[0].totalFees
                : 0;
            this.member.customerstrainer.trainerShare = data[0].trainerShare
                ? data[0].trainerShare
                : 0;
            this.member.customerstrainer.gymShare = data[0].gymShare
                ? data[0].gymShare
                : 0;
        }
    }

    dropdownChange1(selectedMember) {
        var data = this.Trainers.find(
            (x) => x._id === selectedMember.customerstrainer.trainerId
        );
        var index = this.members.indexOf(selectedMember);
        // let memberInd  = this.members.find((x) => x._id === selectedMember._id);
        let memberInd = this.members.find(
            (x) => x.tagNumber === selectedMember.tagNumber
        );
        if (data != null) {
            if (this.member.gPTQuestion === "2P") {
                memberInd.question3 = "YES";
                memberInd.customerstrainer.trainerId = data._id;
                memberInd.customerstrainer.name = data.name;
                memberInd.customerstrainer.totalFees = "20000";
                memberInd.customerstrainer.trainerShare = data.trainerShare
                    ? data.trainerShare
                    : 0;
                memberInd.customerstrainer.gymShare = data.gymShare
                    ? data.gymShare
                    : 0;
            } else if (this.member.gPTQuestion === "3P") {
                memberInd.question3 = "YES";
                memberInd.customerstrainer.trainerId = data._id;
                memberInd.customerstrainer.name = data.name;
                memberInd.customerstrainer.totalFees = "15000";
                memberInd.customerstrainer.trainerShare = data.trainerShare
                    ? data.trainerShare
                    : 0;
                memberInd.customerstrainer.gymShare = data.gymShare
                    ? data.gymShare
                    : 0;
            } else if (this.member.gPTQuestion === "4P") {
                memberInd.question3 = "YES";
                memberInd.customerstrainer.trainerId = data._id;
                memberInd.customerstrainer.name = data.name;
                memberInd.customerstrainer.totalFees = "12000";
                memberInd.customerstrainer.trainerShare = data.trainerShare
                    ? data.trainerShare
                    : 0;
                memberInd.customerstrainer.gymShare = data.gymShare
                    ? data.gymShare
                    : 0;
            }
        }
        this.members[index] = memberInd;
        this.count++;
    }

    getTrainers() {
        this.sourceTrainers = [];
        this.sortedTrainers = [];
        this.loading = true;
        this.appServiceManager.get('branches/' + this.user.branch + '/trainers/actions/active').subscribe(
            (res) => {
                if (res.length > 0) {
                    this.setTrainerData(res);
                } else {
                    this.Trainers = [];
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Trainer Record Found",
                    });
                }
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }

    setTrainerData(Trainers) {
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == false) {
                this.sortedTrainers.push(Trainers[i]);
            }
        }
        this.sortedTrainers.sort(function (a, b) {
            if (
                a.name.substring(0, 1).toLowerCase() <
                b.name.substring(0, 1).toLowerCase()
            ) {
                return -1;
            } else if (
                a.name.substring(0, 1).toLowerCase() >
                b.name.substring(0, 1).toLowerCase()
            ) {
                return 1;
            }
            return 0;
        });
        for (var i = 0; i < Trainers.length; i++) {
            if (Trainers[i].isDelete == true) {
                this.sortedTrainers.push(Trainers[i]);
            }
        }
        this.Trainers = this.sortedTrainers;
        this.sourceTrainers = this.sortedTrainers;
        this.Trainers = [...this.Trainers];
        this.sourceTrainers = [...this.sourceTrainers];
        this.options.push({ label: "Select Trainer", value: 0 });
        this.Trainers.forEach((trainer) => {
            this.options.push({ label: trainer.name, value: trainer._id });
        });
    }
    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch.businessRule == true ){
            this.getBusinessRules();
        }
        if(!this.branch){
            this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
                if (res) {
                    this.branch = res;
                    if(this.branch.businessRule == true ){
                        this.getBusinessRules();
                    }
                } else {
                    this.branch = new IBranch();
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
                }
            },
                (error) => {
                    this.branch = new IBranch();
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                });
        }
        this.isDiscountFormulaReverse = this.branch?.permissions?.isDiscountFormulaReverse
    }
    getCompany() {
        this.company = AuthService.getLoggedInCompanyBranch();
        if (!this.company) {
            this.appServiceManager.get("companies/current").subscribe(
                (res) => {
                    if (res) {
                        this.company = res;
                    } else {
                        this.company = new ICompany();
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }

                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
        }

    }
    validateSignup() {
        if (this.activeIndex === 0) {
            this.activeIndex = 1;
            setTimeout(() => {
                // this.membernameInput.nativeElement.focus();
                // this.autoFocus();
            }, 700);
        } else if (this.activeIndex === 1) {
            this.activeIndex = 2;
        }

    }

    validateMembersSignup() {
        if (this.index === 1) {
            this.index = 0;

            this.nextMembers();
            let ele = document.getElementsByClassName(
                "ui-label-active"
            )[1] as HTMLElement;
            ele.focus();
            if (!this.subPackage.isGreaterthanNoOfMembers) {
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "ui-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            } else {
                if (this.noOfMembers == this.members.length) {
                    this.isMembersRegistered = true;
                    let ele = document.getElementsByClassName(
                        "ui-label-active"
                    )[1] as HTMLElement;
                    ele.focus();
                }
            }
        } else if (this.index === 0) {
            let ele = document.getElementsByClassName(
                "ui-label-active"
            )[1] as HTMLElement;
            ele.focus();
            this.index = 1;
            // document.getElementById("gymShare").focus();
            if (this.noOfMembers == this.members.length) {
                this.isMembersRegistered = true;
                let ele = document.getElementsByClassName(
                    "ui-label-active"
                )[1] as HTMLElement;
                ele.focus();
            }
        } else {
            this.index = 1;
        }
    }

    // pTrainerTab() {
    //     this.members.push(this.member);
    //     if (this.index === 1) {
    //         this.index = 0;
    //     } else {
    //         this.index = 1;
    //     }
    // }

    selectSubcription(subPackage: IPackageBuider, check) {
        this.subPackage = subPackage;
        this.noofMonths=subPackage.noOfMonths;
        this.durationType=subPackage.durationType;
        if(this.durationType == "months"){
            this.noofMonths=subPackage.noOfMonths;
        }
        else if(this.durationType == "weeks"){
            this.noofMonths=subPackage.noOfWeeks;
        }
        else if(this.durationType == "days"){
            this.noofMonths=subPackage.noOfDays;
        }
        this.packageFeeType=subPackage.packageFeeType;
        this.packageRegFeeType=subPackage.packageRegFeeType;
        this.noOfMembers=subPackage.noOfMembers;
        this.packageName=subPackage.packageName;
        this.packageType=subPackage.packageType;
        this.member.monthFee = subPackage.packageFee.toString();
        this.member.question3 = check;
        this.member.packageType = subPackage.packageType;
        this.member.packageName = subPackage.packageName;
        this.member.packageId = subPackage._id;
        this.noOfMembers = subPackage.noOfMembers;
        this.member.registerationFee = subPackage.registerationFee.toString();
        for (let index = 1; index <= this.noOfMembers; index++) {
            this.memberItems.push({
                label: "Membership" + " " + index,
                command: (event: any) => {
                    // this.activeIndex = 0;

                },
            });
        }
        // member register button check if
        if (this.noOfMembers == 1) {
            this.isMembersRegistered = true;
        }
        // TODO: Commented By Mahsam
        // this.index = 1;
        this.validateSignup();
        setTimeout(() => window.scrollTo(0, 0));
    }

    nextMembers() {
        // this.members.push(this.member);
        // this.loader.show();
        // setTimeout(() => {

        //     this.loader.hide();
        // }, 500);
        this.members.push(this.member);
        if (
            !this.subPackage.isGreaterthanNoOfMembers &&
            this.noOfMembers == this.members.length
        ) {
            this.isMembersRegistered = true;
        } else if (
            this.subPackage.isGreaterthanNoOfMembers &&
            this.noOfMembers == this.members.length
        ) {
            this.isMembersRegistered = true;
        }
        else {
            this.member = new IMember();
            setTimeout(() => {
                // this.membernameInput.nativeElement.focus();
                // this.autoFocus();

                this.member.contactDetail.address.country = "Pakistan";
                // this.member.contactDetail.address.city = "Islamabad";
            }, 0);
            const newMembers = this.members.filter((x) => x._id == undefined); // get newly member to get the next tagNumber
            if (newMembers.length > 0) {
                this.member.tagNumber = String(
                    parseInt(newMembers[newMembers.length - 1].tagNumber) + 1
                ).toString();
            } else {
                // this.getAutoMemberID();
            }
            this.member.packageId = this.subPackage._id;
            this.member.packageType = this.subPackage.packageType;
            this.member.packageName = this.subPackage.packageName;
            this.member.profile = "assets/layout/images/avatarBoyImage.png";
            this.member.monthFee = this.subPackage.packageFee.toString();
            this.member.gender = "M";
            this.member.question3 = "NO";
            this.member.question1 = "NO";
            this.member.registerationFee =
                this.subPackage.registerationFee.toString();
            this.member.joiningDate = new Date();
            this.member.contactDetail = new IMemberContact();
            this.member.contactDetail.contact = "";
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.totalFees = "0";
            this.member.gPTQuestion = "";
            this.member.contactDetail.address = new IAddress();
            this.member.contactDetail.address.street = "";
            this.index = 0;
        }
    }

    clearCustomerTrainer() {
        for (let i = 0; i < this.members.length; i++) {
            this.members[i].customerstrainer = new Customerstrainer();
            this.members[i].customerstrainer.totalFees = null;
            this.members[i].question3 = "NO";
            this.count = 0;
        }
    }

    closeFeeCollectionDialog() {
        this.feeInvoiceDialog = false;
    }

    // checkTotalFees() {
    //     if (this.subPackage.packageType === "Month Wise Package" && this.subPackage.packageFeeType === "whole package fee") {
    //         if (this.totalPackageFee !== this.subPackage.packageFee && this.totalReceivedFee != this.subPackage.packageFee) {
    //             if (this.totalPackageFee > this.subPackage.packageFee && this.totalReceivedFee > this.subPackage.packageFee) {
    //                 this.totalPackageFee -= this.totalPackageFee - this.subPackage.packageFee;
    //                 this.totalReceivedFee -= this.totalReceivedFee - this.subPackage.packageFee;
    //             } else if (this.totalPackageFee < this.subPackage.packageFee && this.totalReceivedFee < this.subPackage.packageFee) {
    //                 this.totalPackageFee += this.subPackage.packageFee - this.totalPackageFee;
    //                 this.totalReceivedFee += this.subPackage.packageFee - this.totalReceivedFee;
    //             }
    //         }
    //     }
    // }

   reverse() {
    if (this.index > 0) {
        this.index--;
    }

    if (this.activeIndex > 0) {
        this.activeIndex--;
    }

    if (this.activeIndex === 0) {
        setTimeout(() => window.scrollTo(0, 0));
    }
}
    // reverse() {
    //     if (this.activeIndex > 0) {
    //         this.activeIndex--;
    //         if (this.activeIndex === 0) {
    //             setTimeout(() => window.scrollTo(0, 0));
    //         }
    //     }
    // }
    togglePasswordType() {
        if (this.passwordType === "password") {
            this.passwordType = "text";
        } else {
            this.passwordType = "password";
        }
    }

    validateDetail(member: IMember) {
        // if (parseInt(member.registerationFee) >= 0 && parseInt(member.monthFee) >= 0) {
        if (
            member.question3 === "YES" &&
            parseInt(member.customerstrainer.totalFees) >= 0
        ) {
            return true;
        } else if (member.question3 === "NO") {
            member.customerstrainer.totalFees = '0';
            return true;
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Complete Fields Properly",
            });
            return false;
        }
        // } else {
        //   this.messageService.clear();
        //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: "Fees Should be Greater than zero" });
        //   return false;
        // }
    }

    validateMember(newMember: MemberService) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = new Date();
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = new Date();
        } else {
            this.member.settings.dueDate = new Date(
                this.member.settings.dueDate
            );
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        } else if (
            this.member.emergencyContact.medicalDetail === null ||
            this.member.emergencyContact.medicalDetail === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }
    setMemberData(member: IMember) {
        let date = new Date();
        member.settings = new ISettings();
        if (this.company.globalSetting && this.company.globalSetting.dueDate) {
            member.settings.dueDate = this.company.globalSetting.dueDate;
        } else {
            member.settings.dueDate = new Date();
        }
        this.freezeDetail.daysLeft = 0;
        this.freezeDetail.freezeDate = "";
        this.freezeDetail.isFreeze = false;
        member.freezeDetail = this.freezeDetail;
    }
    profileUploader(event) {
        this.uploadProfile = event.files[0];
        this.member.profile = this.uploadProfile.objectURL;
        this.upload(event.files[0]);
    }
    finish() {
        this.router.navigateByUrl('members/member/' + this.members[0]._id)
    }
    clearProfile($event) {
        this.member.profile = "assets/layout/images/avatarBoyImage.png";
    }
    upload(event) {
        let formData: FormData = new FormData();
        if (this.uploadProfile) {
            formData.append(
                "customerImage",
                this.uploadProfile,
                this.uploadProfile.name
            );
            this._http
                .post(
                    this.config.ServerWithApiUrl + "branches/" + AuthService.getLoggedInBranch() + "/customers/upload",
                    formData
                )
                .subscribe(
                    (res: any) => {
                        this.member.profile =
                            this.config.Server + res.substr(7);
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "success",
                            summary: "Success Message",
                            detail: "Successfully Uploaded",
                        });
                    },
                    (error) => {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: error,
                        });
                    }
                );
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Select Only Images",
            });
        }
    }

    uploadP() {
        let formData: FormData = new FormData();
        if (this.uploadProfile) {
            formData.append(
                "customerImage",
                this.uploadProfile,
                this.uploadProfile.name
            );
            this._http
                .post(
                    this.config.ServerWithApiUrl + "branches/" + AuthService.getLoggedInBranch() + "/customers/upload",
                    formData
                )
                .subscribe(
                    (res: any) => {
                        this.member.profile =
                            this.config.Server + res.substr(7);
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "success",
                            summary: "Success Message",
                            detail: "Successfully Uploaded",
                        });
                    },
                    (error) => {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: error,
                        });
                    }
                );
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: "Please Select Only Images",
            });
        }
    }

    changeProfile() {
        setTimeout(() => {
            // if (this.member.profile.includes("assets/layout/images")) {
            if (this.member.gender === "F") {
                this.member.profile =
                    "assets/layout/images/avatarGirlImage.png";
            } else {
                this.member.profile = "assets/layout/images/avatarBoyImage.png";
            }
            // }
        }, 300);
    }

    captureImageDialogShow() {
        if (this.dialogVisibility == true) {
            this.dialogVisibility = false;
        } else {
            this.dialogVisibility = true;
        }
    }
    handleImage(webcamImage: WebcamImage) {
        this.webcamImage = webcamImage;
        if (webcamImage) {
            this.uploadProfile = this.webcamImage;
            this.member.profile = this.webcamImage.imageAsDataUrl;
            this.webcamImage = null;
        }
    }
    feeChange() {
        if (this.fund.status === "Trainer Fee - Paid") {
            if (
                this.member.customerstrainer &&
                parseInt(this.member.customerstrainer.totalFees) > 0
            ) {
                this.fund.pay = parseInt(
                    this.member.customerstrainer.totalFees
                );
                this.fundInvoice.pay = parseInt(
                    this.member.customerstrainer.totalFees
                );
            } else {
                this.fund.pay = 0;
                this.fundInvoice.pay = 0;
            }
        } else if (this.fund.status === "Monthly Fee - Paid") {
            this.fund.pay = parseInt(this.member.monthFee);
            this.fundInvoice.pay = parseInt(this.member.monthFee);
        } else {
            this.fund.pay = 0;
            this.fund.pay = 0;
        }
    }
    dateChange() {
        this.fund.pay = parseInt(this.member.monthFee);
        this.fundInvoice.pay = parseInt(this.member.monthFee);
    }

    uniqueArrayOfObject(array, distinctMember) {
        // Filter by looking at the next objects if the object is present a second time
        array.forEach((data) => {
            if (data.error === "Fees Already Paid!") {
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: data.error + "of existing members",
                });
            } else {
                let member = distinctMember.find(
                    (x) => x._id == data.customer._id
                );
                if (!member) {
                    distinctMember.push(data.customer);
                }
            }
        });
        return distinctMember;
    }

    feeUpdate(members: any) {
        this.members = members
        const selectedPackage = this.packages.find(
  (packageItem) => packageItem._id === this.members[0]?.packageId
);

if (selectedPackage) {
  this.subPackage = selectedPackage;

  this.members.forEach((member) => {
    member.packageName = selectedPackage.packageName;
  });
}
        this.dateOfJoining= this.members[0].joiningDate;
    }

    /** Same-history group package during multi-member signup. */
    private isSameHistorySignupGroup(): boolean {
        const pkg = this.subPackage;
        if (!pkg) {
            return false;
        }
        const groupPay =
            pkg.groupFeePayByOnePerson === true ||
            (pkg.groupFeePayByOnePerson as unknown) === 'true';
        const sameHistory =
            pkg.sameHistory === true ||
            (pkg.sameHistory as unknown) === 'true';
        return (
            groupPay &&
            (pkg.noOfMembers ?? 0) > 1 &&
            sameHistory &&
            this.members.length > 1
        );
    }

    /** One invoice for all members in a same-history signup fee batch. */
    private resolveSameHistoryGroupMonthlyInvoice(): string | null {
        if (!this.isSameHistorySignupGroup()) {
            return null;
        }
        const primary = this.members[0];
        if (!primary?.tagNumber) {
            return null;
        }
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        return AppUtils.generateInvoiceNo(
            primary.tagNumber,
            primary.feeDetails ?? [],
            currentYear,
            currentMonth,
        );
    }

    private applySameHistorySignupMonthlyFlags(
        fund: IMemberFeeDetails,
        sharedInvoice: string | null,
    ): void {
        if (fund.status !== 'Monthly Fee - Paid' || !this.isSameHistorySignupGroup()) {
            return;
        }
        fund.sameHistoryGroupPayment = true;
        if (sharedInvoice) {
            fund.invoice = sharedInvoice;
        }
    }

    feesUpdate() {
        if (this.subPackage.packageName === "") {
            let packageMonths = 0;
            this.totalPackageFee = 0;
            this.totalReceivedFee = 0;
            for (let index = 0; index < this.members.length; index++) {
                let member = this.members[index];
                let memberPackage: IPackageBuider = this.subPackage;
                member.packageId = memberPackage._id;
                member.packageType = memberPackage.packageType;
                // Month Wise Package: per Month Fee and whole package fee.
                if (
                    memberPackage.packageType === "Month Wise Package" &&
                    memberPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                } else if (
                    memberPackage.packageType === "Month Wise Package" &&
                    memberPackage.packageFeeType === "per Month Fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee =
                        packageMonths * parseInt(member.monthFee);
                }
                // Person Wise Package: per person Fee and whole package fee.
                else if (
                    memberPackage.packageType === "Person Wise Package" &&
                    memberPackage.packageFeeType === "whole package fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / memberPackage.noOfMembers
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                } else if (
                    memberPackage.packageType === "Person Wise Package" &&
                    memberPackage.packageFeeType === "per Person Fee"
                ) {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee =
                        packageMonths * parseInt(member.monthFee);
                } else {
                    packageMonths = memberPackage.noOfMonths;
                    member.monthFee = Math.round(
                        memberPackage.packageFee / packageMonths
                    ).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                }
            }
        }
    }

    feeCollection() {
        var date = new Date();
        this.feeInvoiceDialog = true;
        let packageMonths = 0;
        this.totalPackageFee = 0;
        this.totalReceivedFee = 0;
        this.fund.date = new Date();
        this.totalRegistrationPackageFee = 0;
        this.counterCheck = 0;
        this.totalTrainerFee = 0;
        let invoiceNo;
        const sameHistoryGroupInvoice = this.resolveSameHistoryGroupMonthlyInvoice();
        this.onlineMembers=this.members;
        for (let index = 0; index < this.members.length; index++) {
            let member = this.members[index];
            let memberPackage: IPackageBuider = this.subPackage;
            this.member_id=member._id;
            member.packageId = memberPackage._id;
            member.packageType = memberPackage.packageType;
            // Month Wise Package: per Month Fee and whole package fee.
            if (
                memberPackage.packageType === "Month Wise Package" &&
                memberPackage.packageFeeType === "whole package fee"
            ) {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(
                    memberPackage.packageFee / packageMonths
                ).toString();
                member.customerPackageFee = parseInt(member.monthFee);
            } else if (
                memberPackage.packageType === "Month Wise Package" &&
                memberPackage.packageFeeType === "per Month Fee"
            ) {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(
                    memberPackage.packageFee / packageMonths
                ).toString();
                member.customerPackageFee =
                    packageMonths * parseInt(member.monthFee);
            }

            // Person Wise Package: per person Fee and whole package fee.
            else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths == 1) {
                packageMonths = memberPackage.noOfMonths;
                let mFee = Math.round(memberPackage.packageFee / memberPackage.noOfMembers);

                if (index == (this.members.length - 1)) {
                    member.monthFee = (memberPackage.packageFee - (mFee * (this.members.length - 1))).toString();
                    member.customerPackageFee = parseInt(member.monthFee);

                } else {
                    member.monthFee = Math.round(memberPackage.packageFee / memberPackage.noOfMembers).toString();
                    member.customerPackageFee = parseInt(member.monthFee);
                }

            }
            // Yearly Couples .
            else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = (memberPackage.packageFee / (packageMonths * memberPackage.noOfMembers)).toString();
                member.customerPackageFee = parseInt(member.monthFee);

            }
            // Person Wise Package: per person Fee and whole package fee.
            // else if (
            //     memberPackage.packageType === "Person Wise Package" &&
            //     memberPackage.packageFeeType === "whole package fee"
            // ) {
            //     packageMonths = memberPackage.noOfMonths;
            //     member.monthFee = Math.round(
            //         memberPackage.packageFee / memberPackage.noOfMembers
            //     ).toString();
            //     member.customerPackageFee = parseInt(member.monthFee);
            // }
            else if (
                memberPackage.packageType === "Person Wise Package" &&
                memberPackage.packageFeeType === "per Person Fee"
            ) {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(
                    memberPackage.packageFee / packageMonths
                ).toString();
                member.customerPackageFee =
                    packageMonths * parseInt(member.monthFee);
            } else {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(
                    memberPackage.packageFee / packageMonths
                ).toString();
                member.customerPackageFee = parseInt(member.monthFee);
            }

            this.fund = new IMemberFeeDetails();
            this.fund.invoice = invoiceNo;
            this.fund.day = new Date(member.settings.dueDate)
                .getDate()
                .toString();
            this.fundInvoice.invoice = this.fund.invoice;
            this.fundInvoice.date = date;
            this.fund.year = date.getFullYear();
            this.fund.month = date.getMonth() + 1;
            this.fund.pay = this.totalPackageFee;
            this.fund.pay = this.totalReceivedFee;
            this.fund.date = new Date();
            // if per person registartion fee
            if (memberPackage.registerationFee != 0) {
                member.registerationFee =
                    memberPackage.registerationFee.toString();
                if (
                    memberPackage.packageRegFeeType ===
                    "per Person Registration Fee"
                ) {
                    this.registrationFund = { ...this.fund };
                    this.registrationFund.memberId = member._id;
                    this.registrationFund.pay = memberPackage.registerationFee;
                    this.registrationFund.status = "Registration Fee - Paid";
                    this.registrationFund.type = 'Add Fee';
                    this.registrationFund.scope = 'Member';
                    this.registrationFund.initiatedFrom = 'Signup';
                    this.registrationFund.currentUserData = this.currentUserData;
                    this.registrationFund.createdBy=this.currentUserData.name;
                    console.log("feeCollection " + member.name + " -- per Person Registration Fee - Registration Fee - Paid Obj : ", this.registrationFund);
                    this.feesServicesCall.push(
                        this.appServiceManager.post(
                            "branches/" + this.user.branch + "/customers/actions/pay-fund",
                            this.registrationFund
                        )
                    );
                    this.totalRegistrationPackageFee +=
                        this.subPackage.registerationFee;
                } //if whole package registartion fee
                else if (
                    memberPackage.packageRegFeeType ===
                    "whole package Registration fee"
                ) {
                    this.registrationFund = { ...this.fund };
                    this.registrationFund.memberId = member._id;
                    this.registrationFund.pay = Math.round(
                        memberPackage.registerationFee /
                        memberPackage.noOfMembers
                    );
                    this.registrationFund.status = "Registration Fee - Paid";
                    this.registrationFund.type = 'Add Fee';
                    this.registrationFund.scope = 'Member';
                    this.registrationFund.initiatedFrom = 'Signup';
                    this.registrationFund.currentUserData = this.currentUserData;
                    this.registrationFund.createdBy=this.currentUserData.name;
                    console.log("feeCollection " + member.name + " -- whole package Registration fee - Registration Fee - Paid Obj : ", this.registrationFund);
                    this.feesServicesCall.push(
                        this.appServiceManager.post(
                            "branches/" + this.user.branch + "/customers/actions/pay-fund",
                            this.registrationFund
                        )
                    );
                    this.totalRegistrationPackageFee +=
                        this.subPackage.registerationFee;
                }
            }

            // trainer fees add
            if (member.question3 === "YES") {
                if (member.customerstrainer.totalFees && parseInt(member.customerstrainer.totalFees) != 0) {
                    this.trainerFund = { ...this.fund };
                    this.trainerFund.date = new Date();
                    this.trainerFund.day = new Date(member.customerstrainer.dueDate).getDate().toString();
                    this.trainerFund.memberId = member._id;
                    this.trainerFund.dueDate = member.customerstrainer.dueDate;
                    this.trainerFund.remainingSessionCount = parseInt( member.customerstrainer.sessionCount);
                    this.trainerFund.sessionCount =  member.customerstrainer.sessionCount;
                    this.trainerFund.day = new Date(member.customerstrainer.dueDate).getDate().toString();
                    this.trainerFund.pay = Math.round(
                        parseInt(member.customerstrainer.totalFees)
                    );
                    this.trainerFund.discount = this.trainerDiscount;
                    this.trainerFund.status = "Trainer Fee - Paid";
                    this.trainerFund.type = 'Add Fee';
                    this.trainerFund.scope = 'Member';
                    this.trainerFund.initiatedFrom = 'Signup';
                    this.trainerFund.currentUserData = this.currentUserData;
                    this.trainerFund.createdBy=this.currentUserData.name;
                    console.log("feeCollection " + member.name + " Trainer Fee - Paid Obj : ", this.trainerFund);
                    this.feesServicesCall.push(
                        this.appServiceManager.post(
                            "branches/" + this.user.branch + "/customers/actions/pay-fund",
                            this.trainerFund
                        )
                    );
                    //this.totalTrainerFee += this.trainerFund.pay;
                }
                this.totalTrainerFee=Math.round(
                    parseInt(member.customerstrainer.totalFees));
            }

            for (let index2 = 0, totalRFee = this.totalReceivedFee; index2 <= packageMonths - 1; index2++) {
                var terminDate = new Date();

                let fund = new IMemberFeeDetails();
                var dateInLoop = new Date();
                dateInLoop.setDate(1);
                dateInLoop.setMonth(terminDate.getMonth() + index2);

                let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);

                fund.memberId = member._id;
                fund.invoice = this.fund.invoice;
                fund.date = this.fundInvoice.date;

                if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                    fund.day = lastDayOfMonthInLoop.getDate();
                    fund.month = dateInLoop.getMonth() + 1;
                    fund.year = dateInLoop.getFullYear();
                }
                else {
                    terminDate.setMonth(terminDate.getMonth() + index2);
                    fund.day = this.fund.day;
                    fund.month = terminDate.getMonth() + 1;
                    fund.year = terminDate.getFullYear();
                }

                fund.status = "Monthly Fee - Paid";
                fund.dueDate = member.settings.dueDate;
                if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                    if (index2 == packageMonths - 1) {
                        fund.pay = (memberPackage.packageFee / memberPackage.noOfMembers) - (parseInt(member.monthFee) * (memberPackage.noOfMonths - 1));
                    } else {
                        fund.pay = parseInt(member.monthFee);
                    }
                } else if (memberPackage.packageType === "Month Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                    if (index2 == packageMonths - 1) {
                        fund.pay = (memberPackage.packageFee / memberPackage.noOfMembers) - (parseInt(member.monthFee) * (memberPackage.noOfMonths - 1));
                    } else {
                        fund.pay = parseInt(member.monthFee);
                    }
                } else {
                    fund.pay = parseInt(member.monthFee);
                }
                fund.type = 'Add Fee';
                fund.scope = 'Member';
                fund.initiatedFrom = 'Signup';
                fund.currentUserData = this.currentUserData;
                fund.createdBy=this.currentUserData.name;
                this.applySameHistorySignupMonthlyFlags(fund, sameHistoryGroupInvoice);
                console.log("feeCollection " + member.name + " - At the end - Obj : ", fund);
                this.feesServicesCall.push(
                    this.appServiceManager.post(
                        "branches/" + this.user.branch + "/customers/actions/pay-fund",
                        { customer: member, fund },
                    )
                );
                // this.totalPackageFee += fund.pay;
                // this.totalReceivedFee += fund.pay;
            }
            this.totalPackageFee = memberPackage.packageFee;
            this.totalReceivedFee = memberPackage.packageFee;
        }
        // this.checkTotalFees();
    }
    getBusinessRules() {
        this.appServiceManager
        .get("businessRules/branch/"  + this.branch._id).subscribe(
            (res: any) => {
              if (res.length > 0) {
                this.businessRules = res[0];
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "No Record Found",
                });
              }
            },
            (error) => {
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error.error.message,
              });
            }
          );
      }
    updateFeesFund(totalPackageFee: number, totalReceivedFee: number, totalRegFee: number,nextDueDate:Date,registrationDiscount:number,monthlyDiscount: number, trainerDiscount: number, description: any ,paymentMode:any,feeReceiptImageUrl:any) {

        const extractedValue = paymentMode.split("-")[1];
        if (Array.isArray(this.branch.payments)) {
            this.branch.payments.forEach(payment => {
                if (payment.name == extractedValue) {
                    this.taxType=payment.taxSettings.taxCalculationType;
                    this.taxRate=payment.taxSettings.taxRate;
                }
            });
        }
        this.registrationDiscount = registrationDiscount;
        this.monthlyDiscount = monthlyDiscount;
        this.trainerDiscount=trainerDiscount;
        this.feesServicesCall = [];
        var date = new Date(this.members[0].joiningDate);
        this.feeInvoiceDialog = true;
        this.totalPackageFee = 0;
        this.totalReceivedFee = 0;
        this.totalRegistrationPackageFee = 0;
        this.totalTrainerFee = 0;
        let packageMonths = 0;
        let perMemberReceivedFee = 0;
        let invoiceNo;
        const sameHistoryGroupInvoice = this.resolveSameHistoryGroupMonthlyInvoice();
        const taxRate = this.taxRate;
        const taxType = this.taxType;
        for (let index = 0, totalRFee = totalReceivedFee; index < this.members.length; index++) {
            this.counterCheck = 0;
            let member = this.members[index];
            let memberPackage: IPackageBuider = this.subPackage
            member.packageId = memberPackage._id;
            member.packageType = memberPackage.packageType;
            let packageFee = totalPackageFee / memberPackage.noOfMembers;
            // Month Wise Package: per Month Fee and whole package fee.
            if (memberPackage.packageType === "Month Wise Package" && memberPackage.packageFeeType === "whole package fee") {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(totalPackageFee).toString();
                perMemberReceivedFee = Math.round(totalReceivedFee);
            } else if (memberPackage.packageType === "Month Wise Package" && memberPackage.packageFeeType === "per Month Fee") {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(totalPackageFee).toString();
                perMemberReceivedFee = Math.round(totalReceivedFee);
            }

            // Person Wise Package: per person Fee and whole package fee.
            else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths == 1) {
                packageMonths = memberPackage.noOfMonths;
                let mFee = Math.round(totalPackageFee / memberPackage.noOfMembers);
                let mRFee = Math.round(totalRFee / memberPackage.noOfMembers);



                if (index == (this.members.length - 1)) {
                    member.monthFee = (totalPackageFee - (mFee * (this.members.length - 1))).toString();
                    perMemberReceivedFee = totalRFee - (mRFee * (this.members.length - 1));


                } else {
                    member.monthFee = Math.round(totalPackageFee / memberPackage.noOfMembers).toString();
                    perMemberReceivedFee = mRFee;

                }
            }
            // Yearly Couples .
            else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                packageMonths = memberPackage.noOfMonths;

                member.monthFee = Math.round(totalPackageFee / ( memberPackage.noOfMembers)).toString();
                perMemberReceivedFee = Math.round(totalRFee / ( memberPackage.noOfMembers));
            }
            // Person Wise Package: per person Fee and whole package fee.
            // else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee") {
            //     packageMonths = memberPackage.noOfMonths;
            //     member.monthFee = Math.round(totalPackageFee / memberPackage.noOfMembers).toString();
            //     perMemberReceivedFee = Math.round(totalReceivedFee / memberPackage.noOfMembers);
            // }
            else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "per Person Fee") {
                //
                let packageFee = totalPackageFee / this.members.length;
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(packageFee).toString();
                //
                let packageReceivedFee = totalReceivedFee / this.members.length;
                perMemberReceivedFee = Math.round(packageReceivedFee);

            } else {
                packageMonths = memberPackage.noOfMonths;
                member.monthFee = Math.round(totalPackageFee ).toString();
                perMemberReceivedFee = Math.round(totalReceivedFee);

            }

            this.fund = new IMemberFeeDetails();
            //this.fund.invoice =invoiceNo;
            this.fund.day = new Date(member.settings.dueDate).getDate().toString();
            this.fundInvoice.invoice = this.fund.invoice;
            this.fundInvoice.date = new Date();
            this.fund.year = date.getFullYear();
            this.fund.month = date.getMonth() + 1;
            this.fund.pay = totalPackageFee;
            this.fund.pay = totalReceivedFee;
            this.fund.date = new Date();
            // if per person registeration fee
            if (totalRegFee != 0) {
                if (this.isDiscountFormulaReverse) {
                    this.counterCheck = this.counterCheck + 1;
                    const currentDate = new Date();
                    const currentMonth = currentDate.getMonth() + 1;
                    const currentYear = currentDate.getFullYear();
                    invoiceNo = AppUtils.generateInvoiceNo(member.tagNumber, member.feeDetails, currentYear, currentMonth, false, this.counterCheck);
                    member.totalRegisterationFee = member.registerationFee.toString();
                    member.registerationFee = Math.round(totalRegFee / this.members.length).toString();
                    if (memberPackage.packageRegFeeType === "per Person Registration Fee") {
                        let registrationTax = 0;
                        const registrationFee = Math.round(totalRegFee / this.members.length);
                        if (taxType === "NO_TAX") {
                            registrationTax = 0;
                        }
                        else if (taxType === "WITH_TAX") {
                            registrationTax = (registrationFee==registrationDiscount)? 0 : (registrationFee * taxRate / 100.0);
                        }
                        else if (taxType === "INCLUDING_TAX") {
                            registrationTax = (registrationFee * taxRate / 100.0);
                        }
                        this.registrationFund = { ...this.fund };
                        this.registrationFund.memberId = member._id;
                        this.registrationFund.pay = registrationFee;
                        this.registrationFund.status = "Registration Fee - Paid";
                        this.registrationFund.date = new Date();
                        this.registrationFund.invoice = invoiceNo;
                        this.registrationFund.discount = registrationDiscount;
                        this.registrationFund.tax = registrationTax;
                        this.registrationFund.taxRate = taxRate;
                        this.registrationFund.type = 'Add Fee';
                        this.registrationFund.scope = 'Member';
                        this.registrationFund.initiatedFrom = 'Signup';
                        this.registrationFund.currentUserData = this.currentUserData;
                        this.registrationFund.description = description;
                        this.registrationFund.createdBy = this.currentUserData.name;
                        this.registrationFund.paymentMode = paymentMode;
                        this.registrationFund.isApproved = true;
                        if (this.branch.businessRule == true) {
                            if (this.businessRules.businessRule == "FEEAPPROVALADMIN") {
                                this.registrationFund.isApproved = false;
                            }
                        }
                        if (feeReceiptImageUrl) {
                            this.registrationFund.feeReceiptImageUrl = feeReceiptImageUrl;
                        }
                        let reqBody = {
                            customer: member,
                            fund: this.registrationFund
                        }
                        console.log("updateFeesFund " + member.name + " - Registration Fee - Paid - per Person Registration Fee - Obj : ", this.registrationFund);
                        this.feesServicesCall.push(
                            this.appServiceManager.post(
                                "branches/" + this.user.branch + "/customers/actions/pay-fund",
                                reqBody
                            )
                        );
                        this.totalRegistrationPackageFee +=
                            this.registrationFund.pay;
                    } //if whole package registartion fee
                    else if (memberPackage.packageRegFeeType === "whole package Registration fee") {
                        let registrationTax = 0;
                        const registrationFee = Math.round(totalRegFee / memberPackage.noOfMembers);
                        if (taxType === "NO_TAX") {
                            registrationTax = 0;
                        }
                        else if (taxType === "WITH_TAX") {
                            registrationTax = (registrationFee==registrationDiscount)? 0 : (registrationFee * taxRate / 100.0);
                        }
                        else if (taxType === "INCLUDING_TAX") {
                            registrationTax = (registrationFee * taxRate / 100.0);
                        }
                        this.registrationFund = { ...this.fund };
                        this.registrationFund.memberId = member._id;
                        this.registrationFund.pay = registrationFee;
                        this.registrationFund.status = "Registration Fee - Paid";
                        this.registrationFund.date = new Date();
                        this.registrationFund.invoice = invoiceNo;
                        this.registrationFund.discount = registrationDiscount;
                        this.registrationFund.tax = registrationTax;
                        this.registrationFund.taxRate = taxRate;
                        this.registrationFund.type = 'Add Fee';
                        this.registrationFund.scope = 'Member';
                        this.registrationFund.initiatedFrom = 'Signup';
                        this.registrationFund.currentUserData = this.currentUserData;
                        this.registrationFund.description = description;
                        this.registrationFund.createdBy = this.currentUserData.name;
                        this.registrationFund.paymentMode = paymentMode;
                        this.registrationFund.isApproved = true;
                        if (this.branch.businessRule == true) {
                            if (this.businessRules.businessRule == "FEEAPPROVALADMIN") {
                                this.registrationFund.isApproved = false;
                            }
                        }
                        if (feeReceiptImageUrl) {
                            this.registrationFund.feeReceiptImageUrl = feeReceiptImageUrl;
                        }
                        let reqBody = {
                            customer: member,
                            fund: this.registrationFund
                        }
                        console.log("updateFeesFund " + member.name + " - Registration Fee - Paid - whole package Registration fee - Obj : ", this.registrationFund);
                        this.feesServicesCall.push(
                            this.appServiceManager.post(
                                "branches/" + this.user.branch + "/customers/actions/pay-fund",
                                reqBody
                            )
                        );
                        this.totalRegistrationPackageFee += this.registrationFund.pay;
                    }

                } else {
                     this.counterCheck = this.counterCheck + 1;
                    const currentDate = new Date();
                    const currentMonth = currentDate.getMonth() + 1;
                    const currentYear = currentDate.getFullYear();
                    invoiceNo = AppUtils.generateInvoiceNo(member.tagNumber, member.feeDetails, currentYear, currentMonth, false, this.counterCheck);
                    member.totalRegisterationFee = member.registerationFee.toString();
                    member.registerationFee = Math.round(totalRegFee / this.members.length).toString();
                    if (memberPackage.packageRegFeeType === "per Person Registration Fee") {
                        let registrationTax = 0;
                        const registrationFee = Math.round(totalRegFee / this.members.length);
                        if (taxType === "NO_TAX") {
                            registrationTax = 0;
                        }
                        else if (taxType === "WITH_TAX") {
                            registrationTax = (registrationFee - registrationDiscount) * taxRate / 100.0;
                        }
                        else if (taxType === "INCLUDING_TAX") {
                            registrationTax = (registrationFee - registrationDiscount) * taxRate / 100.0;
                        }
                        this.registrationFund = { ...this.fund };
                        this.registrationFund.memberId = member._id;
                        this.registrationFund.pay = registrationFee;
                        this.registrationFund.status = "Registration Fee - Paid";
                        this.registrationFund.date = new Date();
                        this.registrationFund.invoice = invoiceNo;
                        this.registrationFund.discount = registrationDiscount;
                        this.registrationFund.tax = registrationTax;

                        this.registrationFund.type = 'Add Fee';
                        this.registrationFund.scope = 'Member';
                        this.registrationFund.initiatedFrom = 'Signup';
                        this.registrationFund.currentUserData = this.currentUserData;
                        this.registrationFund.description = description;
                        this.registrationFund.createdBy = this.currentUserData.name;
                        this.registrationFund.paymentMode = paymentMode;
                        this.registrationFund.isApproved = true;
                        if (this.branch.businessRule == true) {
                            if (this.businessRules.businessRule == "FEEAPPROVALADMIN") {
                                this.registrationFund.isApproved = false;
                            }
                        }
                        if (feeReceiptImageUrl) {
                            this.registrationFund.feeReceiptImageUrl = feeReceiptImageUrl;
                        }
                        let reqBody = {
                            customer: member,
                            fund: this.registrationFund
                        }
                        console.log("updateFeesFund " + member.name + " - Registration Fee - Paid - per Person Registration Fee - Obj : ", this.registrationFund);
                        this.feesServicesCall.push(
                            this.appServiceManager.post(
                                "branches/" + this.user.branch + "/customers/actions/pay-fund",
                                reqBody
                            )
                        );
                        this.totalRegistrationPackageFee +=
                            this.registrationFund.pay;
                    } //if whole package registartion fee
                    else if (memberPackage.packageRegFeeType === "whole package Registration fee") {
                        let registrationTax = 0;
                        const registrationFee = Math.round(totalRegFee / memberPackage.noOfMembers);
                        if (taxType === "NO_TAX") {
                            registrationTax = 0;
                        }
                        else if (taxType === "WITH_TAX") {
                            registrationTax = (registrationFee - registrationDiscount) * taxRate / 100.0;
                        }
                        else if (taxType === "INCLUDING_TAX") {
                            registrationTax = (registrationFee - registrationDiscount) * taxRate / 100.0;
                        }
                        this.registrationFund = { ...this.fund };
                        this.registrationFund.memberId = member._id;
                        this.registrationFund.pay = registrationFee;
                        this.registrationFund.status = "Registration Fee - Paid";
                        this.registrationFund.date = new Date();
                        this.registrationFund.invoice = invoiceNo;
                        this.registrationFund.discount = registrationDiscount;
                        this.registrationFund.tax = registrationTax;
                        this.registrationFund.type = 'Add Fee';
                        this.registrationFund.scope = 'Member';
                        this.registrationFund.initiatedFrom = 'Signup';
                        this.registrationFund.currentUserData = this.currentUserData;
                        this.registrationFund.description = description;
                        this.registrationFund.createdBy = this.currentUserData.name;
                        this.registrationFund.paymentMode = paymentMode;
                        this.registrationFund.isApproved = true;
                        if (this.branch.businessRule == true) {
                            if (this.businessRules.businessRule == "FEEAPPROVALADMIN") {
                                this.registrationFund.isApproved = false;
                            }
                        }
                        if (feeReceiptImageUrl) {
                            this.registrationFund.feeReceiptImageUrl = feeReceiptImageUrl;
                        }
                        let reqBody = {
                            customer: member,
                            fund: this.registrationFund
                        }
                        console.log("updateFeesFund " + member.name + " - Registration Fee - Paid - whole package Registration fee - Obj : ", this.registrationFund);
                        this.feesServicesCall.push(
                            this.appServiceManager.post(
                                "branches/" + this.user.branch + "/customers/actions/pay-fund",
                                reqBody
                            )
                        );
                        this.totalRegistrationPackageFee += this.registrationFund.pay;
                    }
                }
            } else {
                member.registerationFee = "0";
            }
            // trainer fees add
            if (member.question3 === "YES") {
                this.counterCheck = this.counterCheck + 1;
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1;
                const currentYear = currentDate.getFullYear();
                invoiceNo = AppUtils.generateInvoiceNo(member.tagNumber, member.feeDetails,  currentYear,  currentMonth, false, this.counterCheck);
                if (member.customerstrainer.totalFees && parseInt(member.customerstrainer.totalFees) != 0) {
                    let trainerTax = 0;
                    const trainerFee = Math.round(parseInt(member.customerstrainer.totalFees));
                    if(taxType === "NO_TAX") {
                        trainerTax = 0;
                    }
                    else if(taxType === "WITH_TAX") {
                        trainerTax = Math.round((trainerFee - trainerDiscount) * taxRate / 100.0);
                    }
                    else if(taxType === "INCLUDING_TAX") {
                        trainerTax = (trainerFee * taxRate) / 100;
                    }
                    this.trainerFund = { ...this.fund };
                    this.trainerFund.day = new Date(member.customerstrainer.dueDate).getDate().toString();
                    this.trainerFund.invoice = invoiceNo;
                    this.trainerFund.memberId = member._id;
                    this.trainerFund.remainingSessionCount = parseInt( member.customerstrainer.sessionCount);
                    this.trainerFund.sessionCount =  member.customerstrainer.sessionCount;
                    this.trainerFund.pay = trainerFee;

                    this.trainerFund.day = new Date(member.customerstrainer.dueDate).getDate().toString();
                    this.trainerFund.dueDate = new Date(member.customerstrainer.dueDate);
                    this.trainerFund.dueDate.setMonth(this.trainerFund.dueDate.getMonth() + 1);
                    this.trainerFund.status = "Trainer Fee - Paid";
                    this.trainerFund.discount = trainerDiscount;
                    this.trainerFund.tax = trainerTax;
                    this.trainerFund.type = 'Add Fee';
                    this.trainerFund.scope = 'Member';
                    this.trainerFund.initiatedFrom = 'Signup';
                    this.trainerFund.currentUserData = this.currentUserData;
                    this.trainerFund.description = description;
                    this.trainerFund.date = new Date();
                    this.trainerFund.createdBy=this.currentUserData.name;
                    this.trainerFund.paymentMode=paymentMode;
                    if(feeReceiptImageUrl){
                        this.trainerFund.feeReceiptImageUrl = feeReceiptImageUrl;
                    }
                    let reqBody ={
                        customer : member ,
                        fund : this.trainerFund
                    }
                    console.log("updateFeesFund " + member.name + " - Trainer Fee - Paid - Obj : ", this.trainerFund);
                    this.feesServicesCall.push(
                        this.appServiceManager.post(
                            "branches/" + this.user.branch + "/customers/actions/pay-fund",
                            reqBody
                        )
                    );
                    this.totalTrainerFee += this.trainerFund.pay;
                }
            }
            if (this.isDiscountFormulaReverse) {
                 for (let index = 0, totalRFee = totalReceivedFee; index <= 0; index++) {
                var terminDate = new Date(this.members[0].joiningDate);
                let fund = new IMemberFeeDetails();
                var dateInLoop = new Date(this.members[0].joiningDate);
                dateInLoop.setDate(1);
                dateInLoop.setMonth(terminDate.getMonth() + index);

                this.counterCheck = this.counterCheck + 1;
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1;
                const currentYear = currentDate.getFullYear();
                invoiceNo = AppUtils.generateInvoiceNo(member.tagNumber, member.feeDetails,  currentYear, currentMonth, false, this.counterCheck);

                let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
                fund.memberId = member._id;
                fund.invoice = invoiceNo;
                // terminDate.setMonth(terminDate.getMonth() + index);
                // fund.month = terminDate.getMonth() + 1;
                fund.date = this.fundInvoice.date;
                let monthlyFee = parseInt(member.monthFee)
                if (memberPackage.packageType === "Month Wise Package" && memberPackage.packageFeeType === "whole package fee") {
                    if (index == (packageMonths - 1)) {
                        let feeTax = 0;
                        const fee = totalRFee - (monthlyFee * (packageMonths - 1));
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee==monthlyDiscount)? 0: fee * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = fee * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                        fund.discount = this.monthlyDiscount;
                    } else {
                        let feeTax = 0;
                        const fee = monthlyFee;
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee==monthlyDiscount)? 0: fee * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = fee * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                        fund.discount = this.monthlyDiscount;
                    }
                } else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths == 1) {
                    let feeTax = 0;
                    const fee = perMemberReceivedFee;
                    if(taxType === "NO_TAX") {
                        feeTax = 0;
                    }
                    else if(taxType === "WITH_TAX") {
                        feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                    }else if(taxType === "INCLUDING_TAX"){
                        feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                    }
                    fund.pay = fee;
                    fund.tax = feeTax;
                }
                else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                    if (index == packageMonths - 1) {
                        let feeTax = 0;
                        const fee = (totalRFee / memberPackage.noOfMembers) - (perMemberReceivedFee * (memberPackage.noOfMonths - 1));
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = fee * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = fee * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                    } else {
                        let feeTax = 0;
                        const fee = perMemberReceivedFee;
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee==monthlyDiscount)? 0: fee * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = fee * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                    }
                }
                else {
                    let feeTax = 0;
                    const fee = perMemberReceivedFee;
                    if(taxType === "NO_TAX") {
                        feeTax = 0;
                    }
                    else if(taxType === "WITH_TAX") {
                        feeTax = (fee==monthlyDiscount)? 0: fee * taxRate / 100.0;
                    }
                    else if(taxType === "INCLUDING_TAX") {
                        feeTax = fee * taxRate / 100.0;
                    }
                    fund.pay = fee;
                    fund.tax = feeTax;
                    fund.discount = this.monthlyDiscount;
                }
                //fund.dueDate = member.settings.dueDate;
                fund.dueDate = nextDueDate;
                fund.dueDateAfterApproval = fund.dueDate;
                fund.isApproved = true;
                if(this.branch.businessRule == true){
                    if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                        let futureDate = moment(this.member.settings.dueDate).add(this.businessRules.gracePeriodForApproval, 'days').toISOString();
                        fund.dueDateAfterApproval = fund.dueDate;
                        fund.dueDate = new Date(futureDate);
                        fund.isApproved = false;
                    }
                }
                 fund.isDelete = member.isDelete;
                 fund.isSynced = member.isSynced;
                 fund.isDefaulter = member.isDefaulter
                // fund.day = this.fund.day;
                // fund.year = terminDate.getFullYear();


                if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                    fund.day = lastDayOfMonthInLoop.getDate();
                    fund.month = dateInLoop.getMonth() + 1;
                    fund.year = dateInLoop.getFullYear();
                }
                else {
                    terminDate.setMonth(terminDate.getMonth() + index);
                    fund.day = this.fund.day;
                    fund.month = terminDate.getMonth() + 1;
                    fund.year = terminDate.getFullYear();
                }


                fund.status = "Monthly Fee - Paid";
                fund.taxRate = taxRate;
                fund.type = 'Add Fee';
                fund.scope = 'Member';
                fund.initiatedFrom = 'Signup';
                fund.oldDate = new Date(this.members[0].joiningDate);
                fund.currentUserData = this.currentUserData;
                fund.date = new Date();
                fund.description = description;
                fund.createdBy=this.currentUserData.name;
                fund.paymentMode=paymentMode;
                fund.noOfMonths = memberPackage.noOfMonths;
                const startMonth = fund.month;
                const dueMonth =fund.month + fund.noOfMonths;
                fund.months = [];
                let currentPayMonth = startMonth;
                while (currentPayMonth < dueMonth) {
                    fund.months.push(currentPayMonth.toString());
                    currentPayMonth++;
                }
                if(feeReceiptImageUrl){
                fund.feeReceiptImageUrl = feeReceiptImageUrl;
                }
                this.applySameHistorySignupMonthlyFlags(fund, sameHistoryGroupInvoice);
                let reqBody ={
                    customer : member ,
                    fund : fund
                }
                console.log("updateFeesFund " + member.name + " - At the end - Obj : ", fund);
                this.feesServicesCall.push(
                  this.appServiceManager.post(
                    "branches/" + this.user.branch + "/customers/actions/pay-fund",
                    reqBody,
                  ),
                );
                if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                    if (index == packageMonths - 1) {
                        this.totalPackageFee += (totalRFee / memberPackage.noOfMembers) - (parseInt(member.monthFee) * memberPackage.noOfMembers)
                    } else {
                        this.totalPackageFee += parseInt(member.monthFee);
                    }
                } else {
                    this.totalPackageFee += parseInt(member.monthFee);
                }
                this.totalReceivedFee += fund.pay;
            }
            } else {
                for (let index = 0, totalRFee = totalReceivedFee; index <= 0; index++) {
                var terminDate = new Date(this.members[0].joiningDate);
                let fund = new IMemberFeeDetails();
                var dateInLoop = new Date(this.members[0].joiningDate);
                dateInLoop.setDate(1);
                dateInLoop.setMonth(terminDate.getMonth() + index);

                this.counterCheck = this.counterCheck + 1;
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1;
                const currentYear = currentDate.getFullYear();
                invoiceNo = AppUtils.generateInvoiceNo(member.tagNumber, member.feeDetails,  currentYear, currentMonth, false, this.counterCheck);

                let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
                fund.memberId = member._id;
                fund.invoice = invoiceNo;
                // terminDate.setMonth(terminDate.getMonth() + index);
                // fund.month = terminDate.getMonth() + 1;
                fund.date = this.fundInvoice.date;
                let monthlyFee = parseInt(member.monthFee)
                if (memberPackage.packageType === "Month Wise Package" && memberPackage.packageFeeType === "whole package fee") {
                    if (index == (packageMonths - 1)) {
                        let feeTax = 0;
                        const fee = totalRFee - (monthlyFee * (packageMonths - 1));
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                        fund.discount = this.monthlyDiscount;
                    } else {
                        let feeTax = 0;
                        const fee = monthlyFee;
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                        fund.discount = this.monthlyDiscount;
                    }
                } else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths == 1) {
                    let feeTax = 0;
                    const fee = perMemberReceivedFee;
                    if(taxType === "NO_TAX") {
                        feeTax = 0;
                    }
                    else if(taxType === "WITH_TAX") {
                        feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                    }else if(taxType === "INCLUDING_TAX"){
                        feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                    }
                    fund.pay = fee;
                    fund.tax = feeTax;
                }
                else if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                    if (index == packageMonths - 1) {
                        let feeTax = 0;
                        const fee = (totalRFee / memberPackage.noOfMembers) - (perMemberReceivedFee * (memberPackage.noOfMonths - 1));
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                    } else {
                        let feeTax = 0;
                        const fee = perMemberReceivedFee;
                        if(taxType === "NO_TAX") {
                            feeTax = 0;
                        }
                        else if(taxType === "WITH_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        else if(taxType === "INCLUDING_TAX") {
                            feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                        }
                        fund.pay = fee;
                        fund.tax = feeTax;
                    }
                }
                else {
                    let feeTax = 0;
                    const fee = perMemberReceivedFee;
                    if(taxType === "NO_TAX") {
                        feeTax = 0;
                    }
                    else if(taxType === "WITH_TAX") {
                        feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                    }
                    else if(taxType === "INCLUDING_TAX") {
                        feeTax = (fee - monthlyDiscount) * taxRate / 100.0;
                    }
                    fund.pay = fee;
                    fund.tax = feeTax;
                    fund.discount = this.monthlyDiscount;
                }
                //fund.dueDate = member.settings.dueDate;
                fund.dueDate = nextDueDate;
                fund.dueDateAfterApproval = fund.dueDate;
                fund.isApproved = true;
                if(this.branch.businessRule == true){
                    if(this.businessRules.businessRule == "FEEAPPROVALADMIN"){
                        let futureDate = moment(this.member.settings.dueDate).add(this.businessRules.gracePeriodForApproval, 'days').toISOString();
                        fund.dueDateAfterApproval = fund.dueDate;
                        fund.dueDate = new Date(futureDate);
                        fund.isApproved = false;
                    }
                }
                 fund.isDelete = member.isDelete;
                 fund.isSynced = member.isSynced;
                 fund.isDefaulter = member.isDefaulter
                // fund.day = this.fund.day;
                // fund.year = terminDate.getFullYear();


                if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                    fund.day = lastDayOfMonthInLoop.getDate();
                    fund.month = dateInLoop.getMonth() + 1;
                    fund.year = dateInLoop.getFullYear();
                }
                else {
                    terminDate.setMonth(terminDate.getMonth() + index);
                    fund.day = this.fund.day;
                    fund.month = terminDate.getMonth() + 1;
                    fund.year = terminDate.getFullYear();
                }


                fund.status = "Monthly Fee - Paid";
                fund.type = 'Add Fee';
                fund.scope = 'Member';
                fund.initiatedFrom = 'Signup';
                fund.oldDate = new Date(this.members[0].joiningDate);
                fund.currentUserData = this.currentUserData;
                fund.date = new Date();
                fund.description = description;
                fund.createdBy=this.currentUserData.name;
                fund.paymentMode=paymentMode;
                fund.noOfMonths = memberPackage.noOfMonths;
                const startMonth = fund.month;
                const dueMonth = fund.month + fund.noOfMonths;
                const startYear = fund.year;
                fund.months = [];
                fund.years = [];
                let currentPayMonth = startMonth;
                let currentPayYear = startYear;
                while (currentPayMonth < dueMonth) {
                    let month = ((currentPayMonth - 1) % 12) + 1;
                    if (month === 0) {
                        month = 12;
                    }
                    fund.years.push(currentPayYear.toString());
                   fund.months.push(month.toString());
                    if (month === 12) {
                        currentPayYear++;
                    }
                    currentPayMonth++;
                }
                if(feeReceiptImageUrl){
                fund.feeReceiptImageUrl = feeReceiptImageUrl;
                }
                this.applySameHistorySignupMonthlyFlags(fund, sameHistoryGroupInvoice);
                let reqBody ={
                    customer : member ,
                    fund : fund
                }
                console.log("updateFeesFund " + member.name + " - At the end - Obj : ", fund);
                this.feesServicesCall.push(
                  this.appServiceManager.post(
                    "branches/" + this.user.branch + "/customers/actions/pay-fund",
                    reqBody,
                  ),
                );
                if (memberPackage.packageType === "Person Wise Package" && memberPackage.packageFeeType === "whole package fee" && memberPackage.noOfMonths > 1) {
                    if (index == packageMonths - 1) {
                        this.totalPackageFee += (totalRFee / memberPackage.noOfMembers) - (parseInt(member.monthFee) * memberPackage.noOfMembers)
                    } else {
                        this.totalPackageFee += parseInt(member.monthFee);
                    }
                } else {
                    this.totalPackageFee += parseInt(member.monthFee);
                }
                this.totalReceivedFee += fund.pay;
            }
            }
            
            if (member._id) {
                console.log("updateFeesFund " + member.name + " - Member update - Obj : ", member);
                this.memeberUpdateServicesCall.push(
                    this.appServiceManager.put(
                        customerUpdateUrl(this.user.branch, member._id),
                        buildMemberUpdatePayload(member, {
                            modifiedBy: this.user?.name,
                            includeCompanyBranch: true,
                        }),
                    )
                );
            }
            // this.checkTotalFees();
        }
    }


    addFund(feeDetail: any) {
        this.updateFeesFund(feeDetail.totalPackageFee, feeDetail.totalReceivedFee, feeDetail.totalRegistrationPackageFee,feeDetail.nextDuedate,feeDetail.registrationDiscount,feeDetail.monthlyDiscount, feeDetail.trainerDiscount,feeDetail.description,feeDetail.paymentMode,feeDetail.feeReceiptImageUrl)
        this.paymentMode= feeDetail.paymentMode;
        this.dialogVisibility = false;
        this.confirmationService.confirm({
            message: "Are you sure you want to add member fee?",
            accept: async () => {
                this.feeInvoiceDialog = false;
                if (this.members.length > 0) {
                    this.loader.show();
                    let response = [];
                    for (let index = 0; index < this.feesServicesCall.length; index++) {
                        const service = this.feesServicesCall[index];
                        let serviceReponse = await service.toPromise();
                        response.push(serviceReponse);
                    }
                    this.memeberServicesCall = [];
                    if (response) {
                        let distinctMembers: IMember[] = [];
                        distinctMembers = this.uniqueArrayOfObject(
                            response,
                            distinctMembers
                        );
                        console.log("addFund this.feesServicesCall forkJoin  res  ", response);
                        distinctMembers.forEach((member) => {
                            if (member._id) {
                                this.memeberServicesCall.push(
                                    this.appServiceManager.get(
                                        customerGetUrl(this.user.branch, member._id)
                                    )
                                );
                            }
                        });
                        console.log("addFund this.memeberServicesCall ", this.memeberServicesCall);
                        this.getCustomerByID();
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "success",
                            summary: "Success Message",
                            detail: "Member Fee Submitted",
                        });
                        
                        this.activeIndex = 3;

                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                        //this.feeInvoiceDialog = false;
                        this.activeIndex = 3;

                    }
                    this.loader.hide();
                    setTimeout(() => {
                        document.getElementById("printButton").focus();
                    }, 300)
                }

            },
            reject: () => {
                this.feeCollection();
            }
        });
    }


    async getCustomerByID() {
        this.members = [];
        let joiningDate;
        this.printInvoiceMembers = [];
        let res = [];
        for (let index = 0; index < this.memeberServicesCall.length; index++) {
            const element = this.memeberServicesCall[index];
            let promiseReturn = await element.toPromise();
            res.push(promiseReturn);
        }
        // forkJoin(this.memeberServicesCall).subscribe(
        // (res: any) => {
        if (res) {
            console.log("getCustomerByID this.memeberServicesCall forkJoin res");
            res.forEach((member: IMember) => {
                console.log("getCustomerByID this.memeberServicesCall forkJoin res member ", member);
                if (member.settings === null || member.settings === undefined) {
                    member.settings = new ISettings();
                    member.settings.dueDate = new Date();
                    member.oldDate = new Date();
                } else if (member.settings.dueDate === null || member.settings.dueDate === undefined) {
                    member.settings = new ISettings();
                    member.settings.dueDate = new Date();
                    member.oldDate = new Date();
                }
                member.joiningDate = new Date(member.joiningDate);
                joiningDate=member.joiningDate;
                this.members.push(member);
            });
            res.forEach((printInvoiceMember: IMember) => {
                this.appServiceManager
                    .get("branches/" + this.user.branch + "/customer-fees/customers/" + printInvoiceMember._id).subscribe(
                        (res: any) => {
                        if (res.length > 0) {
                            printInvoiceMember.feeDetails = res.reverse();
                        } else {
                            this.messageService.clear();
                            this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "No Record Found",
                            });
                        }
                        },
                        (error) => {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "error",
                            summary: "Error Message",
                            detail: error.error.message,
                        });
                        }
                    );
                this.printInvoiceMembers.push(printInvoiceMember);
            });
            this.getCompany();
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: "info",
                summary: "Info Message",
                detail: "Something Went Wrong",
            });
        }
        //     },
        //     (error) => {
        //         this.messageService.clear();
        //         this.messageService.add({
        //             severity: "error",
        //             summary: "Error Message",
        //             detail: error,
        //         });
        //     }
        // );
    }

    async updateCustomer() {
        try {
            this.members = [];
            let response = [];
            for (let index = 0; index < this.memeberUpdateServicesCall.length; index++) {
                const element = this.memeberUpdateServicesCall[index];
                let promiseReponse = await element.toPromise();
                response.push(promiseReponse);
            }
            await this.getCustomerByID();
        } catch (error) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error,
            });
        }

        // forkJoin(this.memeberUpdateServicesCall).subscribe(
        //     (res: any) => {
        //         this.getCustomerByID();
        //     },
        //     (error) => {
        //         this.messageService.clear();
        //         this.messageService.add({
        //             severity: "error",
        //             summary: "Error Message",
        //             detail: error,
        //         });
        //     }
        // );
    }

    searchLocal(value, type, e) {
        this.numb = 0;
        let matchedPackage = [];
        let ele: any;
        if (e.keyCode == 13 && this.index == 0 && this.activeIndex == 0) {
            ele = document.getElementsByClassName("ui-button ui-widget ui-state-default ui-corner-all")[0] as HTMLElement;
            ele.focus();
        }
        if (
            value !== null &&
            value !== undefined &&
            value.toString().length > 0
        ) {
            if (value == "") {
                this.packages = Object.assign([], this.sourcePackages);
            }
            if (!value) {
                this.packages = Object.assign([], this.sourcePackages);
            }
            if (value != "") {
                if (type === "name") {
                    matchedPackage = Object.assign(
                        [],
                        this.sourcePackages
                    ).filter((pack) =>
                        pack.packageName
                            ? pack.packageName
                                .toLowerCase()
                                .indexOf(value.toLowerCase()) > -1
                            : null
                    );
                }
                const distinct = (value, index, self) => {
                    return self.indexOf(value) === index;
                };
                // const source = matchedPackage.concat(matchedPackage);
                this.packages = matchedPackage.filter(distinct);

                if (this.packages.length === 0) {
                    this.packages = [];
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "No Packages Record Found",
                    });
                } else {
                    this.packages = [...this.packages];
                }
            }
        } else {
            this.packages = Object.assign([], this.sourcePackages);
            this.packages = [...this.packages];
        }
    }

    printInvoice(): void {
        this.showPrint = true;
        this.receiptComponent.printInvoice();
    }

    toPrintInvoice($event) {
        if ($event.keyCode == 13) {
            this.printInvoice();
        }
    }

    toFinish($event) {
        if ($event.keyCode == 13) {
            this.finish();
        }
    }

    sendInvoiceEmailAsPdf(): void {
        this.receiptComponent.sendInvoiceEmailAsPdf();
    }

    printCard(membercard) {
        let membercardDetail = this.members.find(
            (x) => x.tagNumber == membercard.tagNumber
        );
        this.member = membercardDetail;
        setTimeout(() => {
            this.print();
        }, 200);
    }

    firstFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            setTimeout(() => {
                this.genderControl.nativeElement.focus();
            }, 3000);
            return;
        }
    }

    secondFocus(e) {
        let control: any;
        if (e.keyCode == 13) {
            e.preventDefault();
            control = document.getElementById("contact").focus();
            return;
        } else if (e.keyCode == 113 && this.index == 0) {
            this.existingMembersDialog = true;
            return;
        }
    }
    thirdFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("street");
            control.focus();
            return;
        } else if (e.keyCode == 113 && this.index == 0) {
            this.existingMembersDialog = true;
            return;
        }
    }

    fourthFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("city");
            control.focus();
            return;
        } else if (e.keyCode == 113 && this.index == 0) {
            this.existingMembersDialog = true;
            return;
        }
    }

    fifthFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 0) {
            e.preventDefault();
            control = document.getElementById("country");
            control.focus();
            return;
        } else if (e.which == 113 || e.keyCode == 113) {
            this.existingMembersDialog = true;
            return;
        }
    }

    trainerFeeFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 1) {
            e.preventDefault();
            control = document.getElementById("trainerFee");
            control.focus();
            return;
        }
    }
    trainerShareFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 1) {
            e.preventDefault();
            control = document.getElementById("trainerShare");
            control.focus();
            return;
        }
    }

    gymShareFocus(e) {
        let control: any;
        if (e.keyCode == 13 && this.index == 1) {
            e.preventDefault();
            control = document.getElementById("gymShare");
            control.focus();
            return;
        }
    }

    autoFocus() {
        let control: any;
        control = document.getElementById("memberName");
        control.focus();
        return;
    }

    signUpHotkeys($event) {
        if ($event.keyCode == 39 || $event.keyCode == 37) {
            var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
            var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
            var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
            if (confirmationBoxButtonExistLength > 0) {
                if (document.activeElement.tagName === "BODY") {
                    confirmationBoxButtonExist[0].focus();
                }
                else {
                    if (document.activeElement === confirmationBoxButtonExist[0]) {
                        confirmationBoxButtonExist[1].focus();
                    }
                    else if (document.activeElement === confirmationBoxButtonExist[1]) {
                        confirmationBoxButtonExist[0].focus();
                    }
                    else {
                        confirmationBoxButtonExist[0].focus();
                    }
                }
            }
        }
        if ($event.keyCode == 39 && this.activeIndex == 0) {
            if (this.numb < this.packages.length - 1) {
                let ele = document.getElementsByClassName("ui-button ui-widget ui-state-default ui-corner-all")[
                    this.numb + 1
                ] as HTMLElement;
                ele.focus();
                this.numb++;
            } else if (this.numb == this.packages.length - 1) {
                this.numb = 0;
                let ele = document.getElementsByClassName("ui-button ui-widget ui-state-default ui-corner-all")[
                    this.numb
                ] as HTMLElement;
                ele.focus();
            }
        }
        //if left arrow key is pressed for previous package
        if ($event.keyCode == 37 && this.activeIndex == 0) {
            let ele = document.getElementsByClassName("ui-button ui-widget ui-state-default ui-corner-all")[
                this.numb - 1
            ] as HTMLElement;
            ele.focus();
            this.numb--;
        }
        for (let m = 49, n = 0; n < this.members.length; n++, m++) {
            if ($event.keyCode == m && this.activeIndex == 2) {
                let ele = document.getElementsByClassName("ui-c")[
                    n
                ] as HTMLElement;
                ele.click();
            }
        }
        if ($event.keyCode == 113 && this.index == 0 && this.activeIndex == 1) {
            this.existingMembersDialog = true;
        } else if (
            $event.keyCode == 115 &&
            this.existingMembersDialog == true
        ) {
            let ele = document.getElementById("aEM").children[0] as HTMLElement;
            ele.click();
        } else if ($event.keyCode == 115 && this.activeIndex == 1) {
            let ele = document.getElementById("selectTrainer")
                .children[0] as HTMLElement;
            ele.click();
        } else if ($event.keyCode == 120) {
            let ele = document.getElementById("tFeeDueDate")
                .children[0] as HTMLElement;
            let ele2 = ele.children[1] as HTMLElement;
            ele2.click();
        }
        else if ($event.keyCode == 113 && this.activeIndex == 2) {
            this.feeCollection();
        }
        else if (($event.keyCode == 39 || $event.keyCode == 37) && !this.showEmailReceiptConfirmationBox && this.activeIndex == 3) {
            if ($event.keyCode == 39) {
                var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
                var nextId = this.enterSteps[nextStep];
                let ele: any = document.getElementById(nextId)
                ele.focus();
                this.currentStep = nextStep;
            } else if ($event.keyCode == 37) {
                var previousStep = this.currentStep == 0 ? 2 : this.currentStep - 1;
                var previousId = this.enterSteps[previousStep];
                let ele: any = document.getElementById(previousId)
                ele.focus();
                this.currentStep = previousStep;
            }

        }
    }

    print(): void {
        let printContents, popupWin;
        printContents = document.getElementById("ID-card").innerHTML;
        popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>Gym ID Card</title>
        <style>
            .ID-card {
                width: 400px;
                height: 250px;
                margin: auto;
                position: relative;
                padding: 20px;
                border-radius: 10px;
                background-image: url("https://i.ibb.co/NL188dQ/white-wood.png");
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.35);
                z-index: 10;
                filter: opacity(95%);
            }

            .top-row {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 5px 0;
            }

            .flag {
                height: 10px;
                margin-right: 5px;
            }

            .card-title,
            .card-title-en {
                line-height: 100%;
            }

            .name,
            .name-en,
            .ID-number {
                font-weight: normal;
            }

            .card-title-en {
                margin-left: auto;
            }

            .middle-row {
                margin-top: 30px;
                display: inline-block;
            }

            .bottom-row {
                position: absolute;
                bottom: 20px;
            }

            .ID-photo {
                display: block;
                width: 100px;
                height: 128px;
                background-repeat: no-repeat;
                background-position: -90px center;
                background-size: 250px;
                position: absolute;
                top: 60px;
                right: 20px;
            }

            .series-number {
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                position: absolute;
                right: -20px;
                bottom: 66px;
                z-index: 10;
            }

            .signature-title {
                position: absolute;
                bottom: 20px;
                right: 20px;
            }

            .signature {
                font-family: "Liu Jian Mao Cao", cursive;
                font-weight: 100;
                position: absolute;
                right: 40px;
                bottom: 35px;
            }

            .ID-number {
                line-height: 100%;
                margin-top: 5px;
            }

            .title {
                text-align: center;
                margin: 16px;
                font-weight: normal;
                font-size: 16px;
                width: 100%;
                position: absolute;
                bottom: 20px;
                z-index: 10;
            }
        </style>
    </head>
    <body>
        ${printContents}</body>
    </html>
    `);
    }

    showAddProfileImage(type) {
        this.addProfileImage = type; // Upload | Cam
        this.isShowAddProfileImage = true;
    }
    hideAddProfileImage() {
        this.isShowAddProfileImage = false
    }

    handleImagefromNewProfile(webcamImage) {
        if (webcamImage) {
            this.uploadProfile = webcamImage;
            this.member.profile = webcamImage;
            this.webcamImage = null;
            this.hideAddProfileImage();
        }
    }

    sendingBackhtmlToPdf($event) {
        this.receiptHtml = $event;
    }

    getMembersEmailsString() {
        let emailArray: any = this.members.map(x => {
            if (x.email != undefined) {
                return x.email;
            }
        });
        return emailArray.toString().replace(/,(?=[^\s])/g, ", ");
    }

    openEmailConfirmation() {
        this.showEmailReceiptConfirmationBox = true;
        this.receiptComponent.getEmailBodyHtml();
        this.email.to = this.getMembersEmailsString();
        this.email.subject = this.branch.name + ' | ' + 'Invoice Receipt' + ' | ' + this.datePipe.transform(new Date(this.fundInvoice.date), 'dd-MMM-yy');
        // this.email.body = this.receiptHtml;
        // this.email.body = '<p><strong>Dear Customer</strong>,</p><p></p><p>Following is an invoice receipt of your<em> Gym Fees</em>, The receipt details are as under:</p>' + this.receiptHtml;
        this.email.body = '<p><strong>Dear Customer</strong>,</p><p>Following is an invoice receipt for your<i> Gym Fees</i>, The receipt details are as follows:</p>' + this.receiptHtml;
    }

    closeEmailConfirmation() {
        this.showEmailReceiptConfirmationBox = false;
    }

    public onBodyChange( { editor }: ChangeEvent ) {
        const data = editor.getData();
        this.email.body = data;
    }

    public onSubjectChange( { editor }: ChangeEvent ) {
        const data = editor.getData();
        this.email.subject = data;
    }

    public onToChange( { editor }: ChangeEvent ) {
        const data = editor.getData();
        this.email.to = data;
    }
}
